import type { DrawerItem } from './drawer-config';
import drawerConfig from './drawer-config';

/**
 * topNavConfig
 *
 * Configuración del menú de navegación superior.
 * Contiene los 8 items principales de nivel 1 que aparecen en la barra superior.
 *
 * Items: Tickets, Cambios, Problemas, Componentes configuración, Envíos,
 * Gestión activos TI, Ubicaciones, Admin
 */
export const topNavConfig: DrawerItem[] = drawerConfig.filter((item) => {
  const mainMenuKeys = [
    'drawer.tickets.ticketsTitle', // Tickets
    'drawer.change.changeTitle', // Cambios
    'drawer.problem.drawerTitle', // Problemas
    'drawer.shipping.shippingTitle', // Envíos
    'drawer.assetManagementIT.assetManagementITTitle', // Gestión activos TI
    'drawer.ubications.ubicationsTitle', // Ubicaciones
    'drawer.admin.adminTitle' // Admin
  ];

  return mainMenuKeys.includes(item.key);
});

/**
 * moreMenuConfig
 *
 * Configuración del menú "Más".
 * Contiene todos los demás items que no están en el menú principal.
 *
 * Incluye: Insumos, Kits, Reportes, Base de datos de conocimiento,
 * Encuestas, Módulo informativo, Ayuda, Soluciones, Lanzamientos
 */
export const moreMenuConfig: DrawerItem[] = drawerConfig.filter((item) => {
  const mainMenuKeys = [
    'drawer.tickets.ticketsTitle',
    'drawer.change.changeTitle',
    'drawer.problem.drawerTitle',
    'drawer.shipping.shippingTitle',
    'drawer.assetManagementIT.assetManagementITTitle',
    'drawer.ubications.ubicationsTitle',
    'drawer.admin.adminTitle'
  ];

  return !mainMenuKeys.includes(item.key);
});

/**
 * allMenuConfig
 *
 * Configuración completa del menú para búsqueda.
 * Combina todos los items del menú principal y "Más".
 */
export const allMenuConfig: DrawerItem[] = [...topNavConfig, ...moreMenuConfig];
